// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"Header_headerTitle__1sW-N"};